<template>
  <div class="mobile-forum">
    <div v-loading="loading"></div>
    <div class="search-box">
      <div class="search-input">
        <svg-icon icon-class="newsearch" class="icon" @click.native="search"></svg-icon>
        <input class="input" type="text" v-model="params.title" @keyup.enter="search" />
      </div>
      <div class="search-filter" @click="handleShowFilter">
        筛选
        <svg-icon icon-class="filter"></svg-icon>
      </div>
      <van-popup v-model="showFilter" round position="bottom">
        <div class="popup-box">
          <div class="popup-item" v-for="(item, index) in navList" :key="item.id">
            <div class="title">{{ item.title }}</div>
            <div class="tags">
              <div class="tag" :class="{ selected: isFilterSelected(index, childItem.value) }" v-for="childItem in item.list" :key="childItem.id" @click="handleClickFilterItem(index, childItem.value)">{{ childItem.text }}</div>
            </div>
          </div>
          <div class="popup-btn-box">
            <div class="btn" @click="handleClickFilterReset">重置</div>
            <div class="btn cur" @click="handleClickFilterConfirm">确定</div>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="page-data-grid" v-if="resData.data.length">
      <div class="grid-item" v-for="(item, index) in resData.data" :key="item.id" @click="goFenceDetail(item.id)">
        <div class="item-img">
          <!-- <div v-if="item.isHaveVideo" class="video-box">
            <img src="@/assets/PC/fenceDetail/player.png" alt="" width="20%">
          </div> -->
          <img :src="item.imgUrl" alt="" class="img">
        </div>
        <div class="item-title">
          {{ item.title }}
        </div>
        <div class="item-btn-box">
          <div class="item-btn">
            <img src="@/assets/PC/studyF/study_type_k.png" />
            <span> {{ item.pv }} </span>
          </div>
          <div class="item-btn" @click="IsLikes(item.id, item.isPraise, index)" title="点赞">
            <img v-if="item.isPraise" src="@/assets/PC/studyF/Liked.png" class="animate__animated animate__fadeIn"/>
            <img v-else src="@/assets/PC/studyF/Like.png" />
            <span> {{ item.praiseNum }} </span>
          </div>
          <div class="item-btn" @click="Enshrines(item.id, item.isCollect, index)" title="收藏">
            <van-icon v-if="item.isCollect" name="like" class=" animate__animated animate__fadeIn" color="#6b18a8"/>
            <van-icon v-else name="like-o" class="xy-icon-Collect" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="noData">
      <img src="@/assets/PC/profile/listNone.png" alt="" />
    </div>
    <div class="loadList">
      <div v-if="!IsMobileList" class="loadbtn" @click="loadListMb">加载更多</div>
      <div v-if="IsMobileList && resData.data.length > 0" class="notDetail">没有更多内容了~</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { debounce,GetWxShares } from '@/utils/common'
import * as Fence from '@/api/library.js'
import { dataState } from '@/api/all.js'
import shadeAlert from "@/components/shadeAlert/index.vue"

export default {
  name: 'FenceIndex',
  components: {
    shadeAlert,
  },
  data() {
    return {
      // !页面loading
      loading: true,
      showFilter: false,
      params: {
        // @ 产品id
        productId: this.$route.query.Id ? this.$route.query.Id : '0',
        // @ 类型id
        typeId: this.$route.query.typesId ? this.$route.query.typesId : '0',
        // @ 方向id
        directionId: this.$route.query.directionsId ? this.$route.query.directionsId : '0',
        // @ 行业id
        industryId: '0',
        // @ 行业二级id
        industryIdSecond: '0',
        // @ 推荐
        sort: '0',
        // @ 页数
        page: 1,
        // @ 条数
        limit: 10,
        // 搜索条件
        title: ''
      },
      filterParams: {
        productId: this.$route.query.Id ? this.$route.query.Id : '0',
        typeId: this.$route.query.typesId ? this.$route.query.typesId : '0',
        industryId: '0'
      },
      // !移动端加载更多
      IsMobileList: false,
      resData: {
        data: [],
        pageCount: 10,
        pageIndex: 1,
        pageSize: 9,
        recordCount: 0
      },
    }
  },
  mounted() {
    const share = {
      title: this.$route.meta.title,
      desc: ''
    }
    GetWxShares(share);
    this.GetInit();
    // 数据统计
    const data ={
      "visitType": 1,
      "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
      "url": window.location.href,
      "pageUrl": "FenceIndex",
      "relationId": this.$route.query.Id
    }
    dataState(data).then(res => {
      sessionStorage.setItem('gid',res.data);
    });
  },
  methods: {
    search() {
      this.params.page = 1
      this.GetInit()
    },
    handleClickFilterItem (index, ChildValue) {
      if (index == 0) {
        this.filterParams.productId = ChildValue
      } else if (index == 1) {
        this.filterParams.typeId = ChildValue
      } else if (index == 2) {
        this.filterParams.industryId = ChildValue
      }
    },
    isFilterSelected (index, childValue) {
      return (index == 0 && childValue === this.filterParams.productId) ||
        (index == 1 && childValue === this.filterParams.typeId) ||
        (index == 2 && childValue === this.filterParams.industryId)
    },
    handleShowFilter () {
      this.filterParams = {
        productId: this.params.productId,
        typeId: this.params.typeId,
        industryId: this.params.industryId
      }
      this.showFilter = true
      console.log(this.navList)
      // this.selectedCategoryType = this.categoryType
      // this.selectedProductType = this.pageParams.productType
    },
    handleClickFilterReset () {
      this.params.title = ''
      this.filterParams = {
        productId: '0',
        typeId: '0',
        industryId: '0'
      }
    },
    handleClickFilterConfirm () {
      this.params.productId = this.filterParams.productId
      this.params.typeId = this.filterParams.typeId
      this.params.industryId = this.filterParams.industryId
      this.params.page = 1
      this.showFilter = false
      this.GetInit()
    },


    // !是否选中状态
    NavActive(index,childId) {
      return (index == 0 && childId === this.params.productId) || (index == 1 && childId === this.params.typeId) || (this.clientWidth > 768 &&  index == 2 && childId === this.params.directionId) || (this.clientWidth < 769 &&  index == 2 && childId === this.params.industryId)
    },
    // !获取数据
    GetInit(IsMobile) {
      this.loading = true
      Fence.GetLibrary(this.params).then(res => {
        this.loading = false
        if (res.status === 1) {
          if(IsMobile) {
            this.resData.data = this.resData.data.concat(res.data)
          } else {
            this.resData = res
          }
          if(this.resData.data.length == this.resData.recordCount) {
            this.IsMobileList = true
          } else {
            this.IsMobileList = false
          }
        } else {
          this.$toast(res.message)
        }
      })
    },
    // !去详情页
    goFenceDetail(Id) {
      this.$router.push("/Home/FenceDetail?id=" + Id);
    },
    // !点赞
    IsLikes(id, IsTrue, index) {
      const data = { resourcesId: id, type: 0 };
      if(!this.$store.state.token){
        this.$toast('请登录后操作!')
        return false;
      }
      debounce(() => {
        if(!IsTrue){
          Fence.Praise(data).then( res => {
            this.$toast(res.message);
            if(res.status == 1) {
              this.resData.data[index].isPraise = true
              this.resData.data[index].praiseNum++
            }
          });
        }else{
          Fence.UnPraise(data).then( res => {
            this.$toast(res.message);
            if(res.status == 1) {
              this.resData.data[index].isPraise = false
              this.resData.data[index].praiseNum--
            }
          });
        }
      }, 1000);
    },
    // !收藏
    Enshrines(id, IsTrue, index) {
      const data = { libraryId: id };
      if(!this.$store.state.token){
        this.$toast('请登录后操作!')
        return false;
      }
      debounce(() => {
        if (!IsTrue) {
          Fence.Collect(data).then(res => {
            this.$toast(res.message);
            if(res.status === 1) {
              this.resData.data[index].isCollect = true
            }
          });
        } else {
          Fence.UnCollect(data).then(res => {
            this.$toast(res.message);
            if(res.status === 1) {
              this.resData.data[index].isCollect = false
            }
          });
        }
      }, 1000);
    },
    // !点击加载更多
    loadListMb() {
      this.loading = true;
      this.params.page++
      this.GetInit(true);
    }
  },
  computed: {
    ...mapState(['Infos', 'clientWidth']),
    ...mapGetters(['module']),
    navList() {
      const list =[
        { id: 10001, title: '产品与方向', list: this.module.products },
        { id: 10002, title: '类型', list: this.module.types },
        { id: 10003, title: '行业', list: this.module.industrys }
      ]
      return list
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.params.page = 1;
        if(this.$route.query.Id == null || this.$route.query.Id == ""){
          this.params.productId = '0'
        }else{
          this.params.productId = val.query.Id;
        }
        this.GetInit();
        // 数据统计
        const data ={
          "visitType": 1,
          "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
          "url": window.location.href,
          "pageUrl": "FenceIndex",
          "relationId": this.$route.query.Id
        }
        dataState(data).then(res => {
          sessionStorage.setItem('gid',res.data);
        });
      },
      // 深度观察监听
      deep: true,
    },
  }
}
</script>

<style lang="scss" scoped>
.mobile-forum{
  padding: vw(24) vw(28);
  min-height: 80vh;
}
.search-box{
  display: flex;
  align-items: center;
  gap: vw(20);
  margin-bottom: vw(24);
}
.search-input{
  flex: 1;
  border: vw(3) solid #6B04A8;
  border-radius: vw(16);
  display: flex;
  align-items: center;
  height: vw(70);
  padding: 0 vw(20);
  gap: vw(10);
  >.icon{
    height: vw(36);
    width: vw(36);
    flex-shrink: 0;
    color: #6B04A8;
  }
  >.input{
    outline: none;
    border: none;
    flex: 1;
    background-color: transparent;
  }
}
.search-filter{
  display: flex;
  align-items: center;
  font-size: vw(24);
  color: #6B04A8;
  gap: vw(6);
}
.popup-box{
  padding: vw(50);
  padding-bottom: vw(150);
  .popup-item{
    display: flex;
    flex-direction: column;
    gap: vw(20);
    margin-bottom: vw(40);
    >.title{
      color: #363D42;
      font-size: vw(24);
      font-weight: bold;
    }
    >.tags{
      display: flex;
      align-items: center;
      gap: vw(28);
      flex-wrap: wrap;
      >.tag{
        display: flex;
        align-items: center;
        height: vw(36);
        background-color: #ededed;
        color: #363D42;
        border-radius: vw(8);
        padding: 0 vw(20);
        font-size: vw(20);
        &.selected{
          background-color: #f4e3ff;
          color: #6B04A8;
        }
      }
    }
  }
  .popup-btn-box{
    margin-top: vw(60);
    display: flex;
    align-items: center;
    gap: vw(26);
    >.btn{
      flex: 1;
      text-align: center;
      height: vw(72);
      line-height: vw(72);
      background-color: #ededed;
      font-size: vw(24);
      font-weight: 500;
      border-radius: vw(8);
      color: #000;
      &.cur{
        background-color: #6B04A8;
        color: #fff;
      }
    }
  }
}

.page-data-grid{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: vw(28) vw(24);
  >.grid-item{
    >.item-img{
      height: vw(190);
      >.img{
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    >.item-title{
      font-size: vw(24);
      line-height: vw(40);
      height: vw(80);
      color: #000;
      margin-bottom: vw(6);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    >.item-btn-box{
      display: flex;
      align-items: center;
      >.item-btn{
        flex: 1;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        >img{
          height: vw(30);
          width: vw(30);
          object-fit: contain;
        }
        >span{
          color: #363D42;
          font-size: vw(24);
        }
      }
    }
  }
}
.noData{
  display: flex;
  justify-content: center;
  >img{
    width: vw(400);
  }
}
.loadList{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: vw(40) 0;
}
.loadbtn{
  padding: vw(14) vw(20);
  background: #f6f6f6;
}
.notDetail{
  color: #ccc;
  font-size: vw(24);
}
</style>